<template>
  <div
    v-if="invitations.length !== 0"
    class="text-h6 mt-32 mb-20">{{ $t("invitation.requests") }}</div>
  <div>
    <InvitationList
      :invitations="invitations"
      :is-load="isLoad"
      type="contract"
      @confirm="handleConfirm"
      @unconfirm="handleUnConfirm"
      :empty-text="$t('invitation.contract.no_invitations_text')"

    />
    <InvitationModals
      v-model:is-show-confirm="isShowConfirm"
      v-model:is-show-un-confirm="isShowUnConfirm"
      :is-loading="isLoadingModal"
      @confirm="confirm"
      @unConfirm="unConfirm"
    />
  </div>
</template>

<script>
import { confirmInvitation, unConfirmInvitation } from "~/api/userInvitationContract";
import invitationMixin from "../invitationMixin";
import InvitationList from "./InvitationList.vue";
import InvitationModals from "./InvitationModals.vue";

export default {
  name: "ContractInvitation",
  components: {
    InvitationList,
    InvitationModals
  },
  mixins: [invitationMixin],
  emits: ['refreshInvitations'],
  methods: {
    async confirm() {
      await this.processConfirm(
        confirmInvitation,
        this.$t("invitation.contract.success_confirm"),
        "contract/fetchContracts",
        this.$t('error.something_went_wrong')
      );
    },
    async unConfirm() {
      await this.processConfirm(
        unConfirmInvitation,
        "invitation.contract.success_un_confirm",
        null,
        this.$t('error.something_went_wrong')
      );
    }
  }
};
</script>